import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "354b7487-8cdc-42c3-b5a2-b81b43669e42", content: "340 Hz", options: {} },
  { id: "c8fb8c7d-fae4-4d9d-b617-364517d394d0", content: "680 Hz", options: {} },
  { id: "089f2adc-1b6a-49fa-96d2-ad05238b5cb9", content: "1700 Hz", options: {} },
  { id: "e431348f-b5dc-40ab-9e77-e627ae2a5702", content: "3400 Hz", options: {} },
  { id: "4fd97ccb-ef05-4584-a360-c275e2b0840d", content: "6800 Hz", options: {} },
  { id: "72b729f1-4283-4d59-93eb-8dbd66a99db9", content: "13400 Hz", options: {} },
];

export const task: Task = {
  id: "248dc38b-8116-4fa6-acc2-3bb20c761a87",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["e431348f-b5dc-40ab-9e77-e627ae2a5702"],
};
